/* Millesève — jauge de livraison offerte du panier (E7.1, E7.4 ; snippet ms-livraison-offerte).
   Dawn remplace le tiroir et le pied de la page panier à chaque changement (quantité, retrait, ajout) :
   la jauge est un nouvel élément à chaque fois. On retient la dernière valeur par emplacement (data-cle)
   et on part de celle-ci (style forcé, sans requestAnimationFrame qui ne tourne pas dans un onglet masqué) pour que le filet glisse jusqu'à la nouvelle valeur (transition CSS). */
if (!customElements.get('ms-jauge')) {
  const precedentes = {};
  customElements.define(
    'ms-jauge',
    class extends HTMLElement {
      connectedCallback() {
        const cle = this.dataset.cle;
        const cible = Number(this.dataset.valeur) || 0;
        const avant = precedentes[cle];
        precedentes[cle] = cible;
        if (avant === undefined || avant === cible) return;
        const trait = this.querySelector('.ms-livraison__trait');
        this.style.setProperty('--ms-jauge', avant / 100);
        if (trait) getComputedStyle(trait).transform; /* fige la valeur de départ avant de poser la cible */
        this.style.setProperty('--ms-jauge', cible / 100);
      }
    }
  );
}
